<script>
import { get, post } from '@/js/axiosClient';

export default {
  methods: {
    getCurrentOrganization(organization_slug) {
      return get(`/v1/organizations/${organization_slug}`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data || err;
        });
    },

    getLiveEvent(organization_id, event_id) {
      return get(`/v1/organizations/${organization_id}/live/${event_id}/player-data`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (
            err?.response?.status === 404 &&
            !this.$route.meta.requiresAuth &&
            err?.response?.data?.message === 'Organization not found'
          ) {
            this.redirectNotFound();
          }
          throw err?.response?.data ?? err;
        });
    },

    getFeatured(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/featured`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (
            err?.response?.status === 404 &&
            !this.$route.meta.requiresAuth &&
            err?.response?.data?.message === 'Organization not found'
          ) {
            this.redirectNotFound();
          }
          throw err?.response?.data ?? err;
        });
    },

    getRecent(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/recent`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    getLiveSchedule(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/live-schedule`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    getVODCategories(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/on-demand-categories`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    getCategories(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/on-demand`, {}, { requireAuth: false })
        .then(res => {
          console.log(res.data.data);
          return res.data.data;
        })
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    getSliderLists(organization_slug, path_slug, data) {
      return get(`/v1/organizations/${organization_slug}/on-demand/${path_slug}`, data, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    getLatestVideo(organization_slug) {
      return get(`/v1/organizations/${organization_slug}/media/latest/player-data`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (
            err?.response?.status === 404 &&
            !this.$route.meta.requiresAuth &&
            err?.response?.data?.message === 'Organization not found'
          ) {
            this.redirectNotFound();
          }
          throw err?.response?.data ?? err;
        });
    },

    firstLoad(organization_slug, path_slug) {
      return get(`/v1/organizations/${organization_slug}/on-demand`, path_slug, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (
            err?.response?.status === 404 &&
            !this.$route.meta.requiresAuth &&
            err?.response?.data?.message === 'Organization not found'
          ) {
            this.redirectNotFound();
          }
          throw err;
        });
    },

    loadMore(organization_slug, subcategories_slug, path_slug) {
      return get(`/v1/organizations/${organization_slug}/on-demand/${subcategories_slug}`, path_slug, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data || null;
        });
    },

    getMedia(organization_search, media_search) {
      return get(`/v1/organizations/${organization_search}/media/${media_search}/player-data`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    getSubcategory(organization_slug, subcategories, path_slug) {
      return get(`/v1/organizations/${organization_slug}/on-demand/${this.sanitizeUrlSegment(subcategories)}`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    getSubcategories(organization_slug, subcategories, path_slug) {
      return get(
        `/v1/organizations/${organization_slug}/on-demand/${this.sanitizeUrlSegment(subcategories)}/${this.sanitizeUrlSegment(path_slug)}`, 
        {}, 
        { requireAuth: false }
      )
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },
    
    // Helper method to sanitize URL segments and handle segments containing dots
    sanitizeUrlSegment(segment) {
      if (!segment) return '';
      // If the segment contains a dot but is not a valid slug, it will cause 404s
      // We encode dots to ensure they're properly handled in API requests
      return encodeURIComponent(segment);
    },

    searchMedia(value, page, id) {
      return get(`/v1/media/search`, 
        { 
          type: '', 
          term: value, 
          'sort[column]': 'name', 
          'sort[order]': 'asc',
          page,
          organization_id: id 
        }, 
        { requireAuth: false }
      )
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    adImpression(id) {
      return post(`/v1/advertisement/${id}/impressions`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    adClickImpression(id) {
      return post(`/v1/advertisement/${id}/clickthroughs`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    sendConnectMessage(slug, data) {
      return post(`/v1/organizations/${slug}/connections`, data, { requireAuth: false })
        .then(res => res.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    getInitMediaBySeries(slug, path_slug, data) {
      return get(`/v1/organizations/${slug}/on-demand${path_slug}`, data, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    getMediaBySeries(slug, path_slug, data) {
      return get(`/v1/organizations/${slug}/on-demand/${path_slug}`, data, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    // CHAT CALLS:
    fetchAllMessages(eventId) {
      return get(`/v1/events/${eventId}/chat/history`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    joinChatFetch(eventId, data) {
      return post(`/v1/events/${eventId}/chat/connect`, data, { requireAuth: false })
        .then(res => res)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    chatMessageFetch(eventId, data) {
      return post(`/v1/events/${eventId}/chat/messages`, data, { requireAuth: false })
        .then(res => res)
        .catch(err => {
          throw err?.response?.data ?? err;
        });
    },

    getOrganizationPlaylist(organizationSlug) {
      return get(`/v1/schedule/${organizationSlug}/playlist`, {}, { requireAuth: false })
        .then(res => res.data.data)
        .catch(err => {
          if (err?.response?.status === 404 && !this.$route.meta.requiresAuth) this.redirectNotFound();
          throw err?.response?.data ?? err;
        });
    },

    redirectNotFound() {
      window.location.href = 'https://vlifemedia.com';
    }
  }
};
</script>
